import { useMutation, useQueryClient } from "react-query";

import { crearCliente, updateCliente, deleteCliente} from '../../services/Clientes';

import { toast } from 'react-hot-toast';
const queryKey = "cliente";

export const useClienteMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addCliente = useMutation((body) => crearCliente(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateClienteD = useMutation(
    (body) => updateCliente( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeCliente = useMutation((id) => deleteCliente( id), {
    onSuccess,
    onError,
  });

  return { addCliente, updateClienteD, removeCliente };
};
export default useClienteMutations;